import emailjs from "@emailjs/browser";
import { yupResolver } from "@hookform/resolvers/yup";
import { useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { emailSchema } from "../Validations/BaseSchema";
import * as yup from "yup";
export default function Feedback() {
  const form = useRef();
  const reply = () =>
    yup.object({
      reply_to: emailSchema.required(),
      from_name: yup.string().required(),
      message: yup.string().required(),
    });
  const [mess, setMess] = useState("");
  const {
    register,

    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(reply()),
  });

  const sendEmail = (e) => {
    emailjs
      .sendForm("service_m7v455g", "template_2p3lvlx", form.current, {
        publicKey: "5PP9Jt-jfLr3a8cqX",
      })
      .then(
        () => {
          setMess("thanks for Your feedback");
          form.current.reset();
          console.log("SUCCESS!");
        },
        (error) => {
          setMess("something went wrong, try again later");
          console.log("FAILED...", error.text);
        },
        setTimeout(() => {
          setMess("");
        }, 5000)
      );
  };
  console.log(errors);

  return (
    <div className="d-flex align-items-center  flex-around full-w sec-c">
      <form ref={form} onSubmit={handleSubmit(sendEmail)}>
        <label className={`${errors.reply_to ? "err-c" : ""}`}>
          Email
          <input
            className="sec-bg-c prime-c radius-5 p-5 mt-5 mb-5"
            type="text"
            name="reply_to"
            {...register("reply_to")}
          />
        </label>
        <label>
          Name
          <input
            className="sec-bg-c prime-c radius-5 p-5 mt-5 mb-5"
            type="text"
            name="from_name"
            {...register("from_name")}
          />
        </label>
        <label className="mt-5 block">
          Feedback
          <textarea
            rows={8}
            name="message"
            {...register("message")}
            className="sec-bg-c prime-c radius-5 p-5 mt-5 mb-5"
          />
        </label>
        <button className="full-button-mixed radius-5" type="submit">
          send
        </button>
        {mess && <p className="txt-center">{mess}</p>}
      </form>
    </div>
  );
}
